module.exports = __webpack_public_path__ + "img/banner-1.c228f452.png";